export const getMainSendRequestParams = ({ auth, method = "read", params }) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const isUpdateMode = method === "update";
  const inFix = isUpdateMode ? "/:ldapId" : "";
  const apiUrl = `${apiBaseUrl}/sites/:siteId/settings/profileLdap${inFix}.${method}`;

  const requestParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.orgs?.id,
      siteId: auth.sites?.id,
    },
  };

  const requestParams = isStandaloneMode ? requestParamsConfig["standalone"] : requestParamsConfig["nonStandalone"];
  if (isUpdateMode && params) requestParams.ldapId = params.ldapId;

  return { apiUrl, requestParams };
}

export const getInitTableData = ({ responseData }) => {
  const dataArray = Array.isArray(responseData) ? responseData : (responseData?.data ?? []);
  return dataArray.map(item => ({ ...item }));
}

export const getCleanPayload = ({ selectedLdap }) => {
  if (!selectedLdap) return selectedLdap;

  const payload = {
    ...selectedLdap,
    port: selectedLdap.port ? +selectedLdap.port : selectedLdap.port,
  };

  return payload;
}
